import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const MarketingFooter: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isLandingPage = location.pathname === '/' || location.pathname === '/homepage' || location.pathname === '/company';

  const handleSectionClick = (sectionId: string) => {
    if (!isLandingPage) {
      navigate(`/#${sectionId}`);
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const headerOffset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({ top: offsetPosition, behavior: 'instant' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        const headerOffset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({ top: offsetPosition, behavior: 'instant' });
      }
    }
  };

  return (
    <footer className="bg-gray-900 dark:bg-slate-950 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact-sales?source=footer" className="hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h3 className="text-white font-semibold mb-4">Solutions</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#steps-challenge"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSectionClick('steps-challenge');
                  }}
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  Steps Challenge
                </a>
              </li>
              <li>
                <a
                  href="#multi-activity"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSectionClick('multi-activity');
                  }}
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  Multi-activity Challenges
                </a>
              </li>
              <li>
                <a
                  href="#team-challenge"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSectionClick('team-challenge');
                  }}
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  Team Challenge
                </a>
              </li>
              <li>
                <a
                  href="#virtual-marathon"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSectionClick('virtual-marathon');
                  }}
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  One Day Virtual Marathon
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#resources"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSectionClick('resources');
                  }}
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  Resources
                </a>
              </li>
              <li>
                <Link to="/terms" className="hover:text-white transition-colors">
                  Terms and Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400">
            © Fitzaa. 2025 All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default MarketingFooter;

